<template>
  <div @click.stop="handleEnvelop" class="popup-envelop">
    <img v-if="popup.ext === 'open'" class="envelop-bg" src="/dg3/static/assets/open-envelop.png" />
    <div v-else class="envelop-result">
      <div class="envelop-contents">
        <div v-if="popup.ext > 0" class="envelop-desc">
          <h5 style="margin-top: .2rem">哇塞，抢到现金红包</h5>
          <h5 style="margin-top: .3rem">
            <span class="money">{{ popup.ext }} </span> 元
          </h5>
          <h5 class="foot">— 已存入“微信零钱” —</h5>
        </div>
        <div v-else class="envelop-desc">
          <img class="fail-img" src="/dg3/static/emoji/72x72/1f62d.svg">
          <h5>哎呀，手速慢了</h5>
          <h5 style="margin-top: .08rem">红包已抢完</h5>
        </div>
      </div>
      <div @click="$store.commit('closePopup')" class="envlop-btn">
        <span>我知道了</span>
        <img src="/dg3/static/assets/popup-btn.png" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['popup', 'room', 'user'],

  methods: {
    handleEnvelop () {
      if (this.popup.ext === 'open') {
        this.$store.commit('closePopup')
        this.toast.loading({ duration: 0, message: '', forbidClick: true })

        this.request({
          url: '/liveReceive/receiveRedP',
          data: { liveSendId: this.popup.id },
        }).then(res => {
          this.toast.clear()

          setTimeout(() => {
            this.$store.commit('changePopupVisible', {
              visible: true, 
              status: 'envelop', 
              ext: res.result ? (res.result / 100).toFixed(2) : 0
            })
          }, 200)
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.popup-envelop {
  position: relative;
  .envelop-bg {
    display: block;
    width: 100%;
  }
  .envelop-result {
    display: flex;
    flex-direction: column;
    align-items: center;
    .envelop-contents {
      width: 100%;
      height: 6.7rem;
      background: url(/dg3/static/assets/envelop-result.png) no-repeat;
      background-size: 100%;
      .envelop-desc {
        padding-top: 1.9rem;
        .money {
          display: inline-block;
          font-size: .68rem; 
          line-height: .68rem; 
        }
        .fail-img {
          display: block;
          margin: 0 auto .25rem;
          width: .85rem;
        }
        .foot {
          margin-top: 2.7rem; 
          font-size: .28rem;
          line-height: .28rem;
          color: #F7931E; 
        }
      }
      h5 {
        text-align: center;
        color: #D32F43;
        font-size: .32rem;
        line-height: .32rem;
      }
    }
  }
  .envlop-btn {
    position: relative;
    margin-top: .4rem;
    width: 4rem;
    span {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      color: #D32F43;
      font-size: .4rem;
    }
    img {
      display: block;
      width: 100%;
    }
  }
}
</style>